export enum DeviceAlarmStatusEnum {
  ONLINE = 0,
  OFFLINE = 1,
  WARNING = 2
}

export class DeviceAlarmStatus {
  deviceId!: number;
  status!: DeviceAlarmStatusEnum;
  ts!: number;
  message!: string;

  constructor(deviceId: number, status: DeviceAlarmStatusEnum, ts: number = new Date().getTime(), message: string) {
    this.deviceId = deviceId;
    this.status = status;
    this.ts = ts;
    this.message = message;
  }
}
